<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
        @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
        @current-change="pageChange">
        <template slot="menuLeft">
          <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="downloadExcelWorkOrder">下载所有Excel</el-button>
          <el-button type="text" icon="el-icon-download" size="small" plain
            @click.stop="downloadCode({ type: 2 })">下载防水报单通用码</el-button>
          <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="downloadExcelActualArea">下载防水财务Excel</el-button>
          <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="downloadExcelWaterproofDelivery">下载防水交付Excel</el-button>
          <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="openCostDetailDownload">下载防水费用拆分</el-button>
          <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="openMaterialDownload('pending')">下载每日汇总</el-button>
          <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="openMaterialDownload('writtenOff')">下载预约核销材料</el-button>
          <el-button type="text" icon="el-icon-tickets" size="mini" plain
            @click.stop="financeExportVisible = true">财务导出记录</el-button>
        </template>
        <template slot-scope="scope" slot="menuBtn">
          <el-button type="text" icon="el-icon-view" size="small" plain @click.stop="handleView(scope.row)">查看
          </el-button>
          <el-button type="text" icon="el-icon-edit" size="small" plain v-if="permission.JOINS_SALES_CLOUD_WF_EDIT"
            @click.stop="handleEdit(scope.row, scope.index)">编辑
          </el-button>
          <el-button type="text" icon="el-icon-document" size="small" plain @click.stop="handleViewStage(scope.row)">工单
          </el-button>
          <el-button type="text" icon="el-icon-printer" size="small" plain
            :loading="merchantFeePrintLoadingKey === scope.row.id + ':MAIN'"
            v-if="scope.row.orderStatus == 'TO_BE_EVALUATED' || scope.row.orderStatus == 'COMPLETE'"
            @click.stop="handlePrintMerchantFees(scope.row, MERCHANT_FEE_PRINT_SCOPE_MAIN)">打印商家费用</el-button>
          <el-button type="text" icon="el-icon-printer" size="small" plain
            :loading="merchantFeePrintLoadingKey === scope.row.id + ':SUPPLEMENTARY'"
            v-if="scope.row.orderStatus == 'TO_BE_EVALUATED' || scope.row.orderStatus == 'COMPLETE'"
            @click.stop="handlePrintMerchantFees(scope.row, MERCHANT_FEE_PRINT_SCOPE_SUPPLEMENTARY)">打印商家补刷费用</el-button>
          <el-button type="text" icon="el-icon-view" size="small" plain
            v-if="scope.row.orderStatus == 'COMPLETE' || scope.row.orderStatus == 'TO_BE_EVALUATED'"
            @click.stop="evaluateInfoView(scope.row)">查看评价</el-button>
          <el-button type="text" icon="el-icon-plus" size="small" plain
            v-show="scope.row.status == 'WAIT_AUDIT' && scope.row.reference && permission.JOINS_SALES_CLOUD_WF_REBATES"
            @click.stop="handleRebates(scope.row)">待返利</el-button>
          <el-button type="text" icon="el-icon-delete" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_WF_CANCEL"
            @click.stop="handleCancelOrder(scope.row, scope.$index)">作废
          </el-button>
          <el-button type="text" icon="el-icon-edit" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_WF_STEP_ASSIGN"
            @click.stop="handleAssignEngineerStage(scope.row)">分阶段指派工程师
          </el-button>
          <el-button type="text" icon="el-icon-tickets" size="small" plain
            v-if="scope.row.engineeringOrderId"
            @click.stop="handleViewMeasurementForm(scope.row, 'NORMAL')">查看收方表
          </el-button>
          <el-button type="text" icon="el-icon-tickets" size="small" plain
            v-if="scope.row.engineeringOrderId && hasSupplementaryPhase(scope.row.phaseList)"
            @click.stop="handleViewMeasurementForm(scope.row, 'SUPPLEMENTARY')">查看补刷收方表
          </el-button>
          <!-- 报售后 -->
          <el-button type="text" icon="el-icon-news" size="small" plain
            v-if="scope.row.orderStatus == 'COMPLETE' || scope.row.orderStatus == 'TO_BE_EVALUATED'"
            @click.stop="handleAfterSales(scope.row)">报售后
          </el-button>
          <!-- 查看该主订单关联的全部售后单 -->
          <el-button type="text" icon="el-icon-search" size="small" plain
            v-if="scope.row.orderStatus == 'COMPLETE' || scope.row.orderStatus == 'TO_BE_EVALUATED'"
            @click.stop="handleViewAfterSaleList(scope.row)">查看售后
          </el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" icon="el-icon-news" @click="handleClick(scope.row)" :loading="isLoading" size="mini"
            v-if="permission.JOINS_SALES_CLOUD_WF_STEP_CONFIRM">
            {{ scope.row.stepName }}
          </el-button>
        </template>
        <template slot-scope="scope" slot="orderStatus">
          <div v-for="obj of orderStatusList" :key="obj.value">
            <el-tag v-if="obj.value == scope.row.orderStatus" :type="orderStatusType(obj.label)">
              {{ obj.label }}</el-tag>
          </div>
        </template>
        <template slot-scope="scope" slot="phaseList">
          <div v-if="scope.row.phaseList && scope.row.phaseList.length">
            <el-tooltip placement="top" effect="dark">
              <div slot="content">
                <div v-for="phase in scope.row.phaseList" :key="phase.sort" style="line-height: 24px;">
                  {{ phase.sort }}阶段{{ phase.name }} - <b>{{ phaseStatusLabel(phase.status) }}</b>
                </div>
              </div>
              <div style="display: flex; flex-wrap: wrap; gap: 4px;">
                <el-tag v-for="phase in scope.row.phaseList" :key="phase.sort"
                  :type="phaseStatusType(phase.status)" size="mini">
                  {{ phase.sort }}阶段：{{ phase.name }}({{ phaseStatusLabel(phase.status) }})
                </el-tag>
              </div>
            </el-tooltip>
          </div>
          <span v-else>-</span>
        </template>
        <template slot="picUrlForm">
          <ImageUpload action="#" :multiple="true" :limit="5" @uploaded="handleUploaded" :uploaded-images="picUrl" />
        </template>
        <template slot-scope="scope" slot="picUrl">
          <viewer :images="formmaterImage(scope.row.picUrl)">
            <img v-for="src in formmaterImage(scope.row.picUrl)" :src="src" :key="src" width="20">
          </viewer>
        </template>
      </avue-crud>
      <!-- <el-dialog title="生成提货单" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
        <el-form :model="tabelObj" :rules="rules" label-width="100px" ref="tabelObj">
          <el-row>
            <el-col :span="12">
              <el-form-item label="前仓" prop="warehouseId">
                <el-select v-model="tabelObj.warehouseId" placeholder="请选择前仓">
                  <el-option v-for="item in WarehouseList" :key="item.id" :label="item.warehouseName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工程师" prop="engineerId" required>
                <el-select v-model="tabelObj.engineerId" placeholder="请选择工程师" filterable remote
                  :remote-method="handleRemote" clearable>
                  <el-option v-for="item in users" :key="item.id" :label="item.realName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="confirm" v-if="permission.JOINS_SALES_CLOUD_WF_DELIVERY_CONFIRM">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="生成验收单" :visible.sync="dialogAcceptanceVisible" width="50%" :close-on-click-modal="false">
        <el-form :model="superiorEr" :rules="rules" label-width="100px" ref="superiorEr">
          <el-row>
            <el-col :span="12">
              <el-form-item label="工程师" prop="engineerId" required>
                <el-select v-model="superiorEr.engineerId" placeholder="请选择工程师" filterable remote
                  :remote-method="handleRemote" clearable>
                  <el-option v-for="item in users" :key="item.id" :label="item.realName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelHandleAcceptance">取 消</el-button>
          <el-button type="primary" @click="confirmHandleAcceptance" v-if="permission.JOINS_SALES_CLOUD_WF_ACCEPTANCE_CONFIRM">确 定</el-button>
        </span>
      </el-dialog> -->
      <el-dialog :title="currentDialogTitle" :visible.sync="isDialogVisible" width="30%">
        <div v-if="isInputVisible">
          <el-input v-model="inputValue" placeholder="请输入内容" style="width: 100%; margin-bottom: 10px;"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isDialogVisible = false" icon="el-icon-close">取 消</el-button>
          <el-button type="primary" @click="submitInput" icon="el-icon-check" :loading="isLoading" v-if="permission.JOINS_SALES_CLOUD_WF_STEP_CONFIRM">确 定</el-button>
        </span>
      </el-dialog>
      <viewOrder :visibleOrder.sync="viewOrderVisible" :orderId="orderId" :evaluateInfo="evaluateInfo" :id="idNow"
        @refresh="handleList" />
      <viewEvaluation :visibleOrder.sync="evaluationVisible" :orderId="evaluationOrderId"
        :declarationInfo="evaluationDeclaration" />
      <viewAcceptanceOrder :visibleAcceptanceOrder.sync="viewAcceptanceVisible" :orderId="engineeringOrderId"
        :id="idNow" :infoDetail="tempInfo" @refresh="handleList" ref="viewAcceptanceRef" />
      <viewWaterProofStage :visibleStage.sync="viewStageVisible" :orderId="idNow" :status="wforderStatus" :id="idNow"
        :infoDetail="tempInfo" @refresh="handleList" @openViewOrder="handleOpenViewOrder" />
      <!-- <el-dialog title="指派监理" :visible.sync="dialogVisible1" width="500px" :close-on-click-modal="false">
        <div v-if="loadingEngineers">加载中...</div>
        <el-form v-else :model="assignForm" :rules="rules1" ref="assignForm">
          <el-form-item label="选择监理" prop="engineeringSupervisor">
            <el-select v-model="assignForm.engineeringSupervisor" placeholder="请选择监理" filterable>
              <el-option v-for="engineer in engineers" :key="engineer.userId" :label="engineer.username"
                :value="engineer.userId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel1">取消</el-button>
          <el-button type="primary" @click="saveInfo" v-if="permission.JOINS_SALES_CLOUD_WF_ASSIGN_SUPERVISOR">确认指派</el-button>
        </span>
      </el-dialog> -->
      <!-- <el-dialog title="防水面积配置" :visible.sync="waterproofAreaDialogVisible" width="50%" :close-on-click-modal="false">
        <el-card shadow="never" style="margin-bottom: 10px;">
          <div slot="header" style="font-weight:bold;">添加区域面积配置</div>
          <el-form :model="areaForm" label-width="70px" style="margin-top: 20px;">
            <el-form-item label="新增配置">
              <el-select v-model="areaForm.name" placeholder="请选择区域名称" style="width: 200px;">
                <el-option v-for="item in areaNameOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
            <el-form-item label="面积(㎡)">
              <el-input v-model="areaForm.area" type="number" placeholder="请输入面积" style="width: 200px;" />
            </el-form-item>
            <el-form-item align="right">
              <el-button type="text" @click="addWaterproofArea" icon="el-icon-plus">添加</el-button>
            </el-form-item>
          </el-form>
          <el-card shadow="never" style="margin-bottom: 10px;">
            <div slot="header" style="font-weight:bold;">已添加区域面积配置</div>
            <el-table :data="waterproofAreaList" style="width: 100%; margin-top: 20px;">
              <el-table-column prop="name" label="名称" width="120" />
              <el-table-column prop="area" label="面积(㎡)" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.area" size="mini" @input="onAreaInput(scope.row)" type="number" />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="deleteWaterproofArea(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-card>
        <el-card shadow="never" style="margin-bottom: 10px;">
          <div slot="header" style="font-weight:bold;">工单动态表单配置</div>
          <el-table :data="dynamicFormList" style="width: 100%;">
            <el-table-column prop="fieldName" label="字段名称" width="150" />
            <el-table-column prop="fieldValue" label="字段值">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fieldValue" size="mini"
                  :type="scope.row.inputType === 'number' ? 'number' : 'text'" />
              </template>
            </el-table-column>
            <el-table-column prop="inputType" label="类型" width="100">
              <template slot-scope="scope">
                {{ scope.row.inputType === 'number' ? '数字' : '文本' }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <span slot="footer" class="dialog-footer">
          <el-button @click="waterproofAreaDialogVisible = false" icon="el-icon-close">取 消</el-button>
          <el-button type="primary" @click="submitWaterproofArea" icon="el-icon-check" :loading="isLoading" v-if="permission.JOINS_SALES_CLOUD_WF_AREA_CONFIRM">确
            定</el-button>
        </span>
      </el-dialog> -->
      <assign-engineer-stage :visible.sync="assignEngineerVisible" :order-id="assignEngineerOrderId"
        :root-depart-id="rootDepartmentId" :shop-id="currentShopId" :shop-name="currentShopName"
        :contact-mobile="currentShopMobile" :custom-address="currentCustomAddress"
        :order-info="assignEngineerOrderInfo" @refresh="handleList"
        @bindBusinessEntity="handleBindBusinessEntity" />
      <merchant-view :visible.sync="viewDialogVisible" :id="viewId" />
      <after-sales :visibleAfterSales.sync="handleAfterSalesDialog" :declaration="afterSalesRow"
        @success="handleList" />
      <after-sale-list-dialog :visible.sync="afterSaleListVisible" :declaration="afterSaleListRow" />
      <view-measurement-form :visible.sync="measurementFormVisible"
        :engineering-order-id="measurementFormOrderId" :type="measurementFormType" />
      <el-dialog title="请绑定经营主体" :visible.sync="businessEntityDialogVisible" width="700px"
        :close-on-click-modal="false">
        <div class="business-entity-dialog-content">
          <el-form :model="businessEntityForm" label-width="100px" style="margin-bottom: 20px;">
            <el-form-item label="店铺名称">
              <el-input v-model="currentShopName" disabled></el-input>
            </el-form-item>
            <el-form-item label="店铺电话">
              <el-input v-model="currentShopMobile" disabled></el-input>
            </el-form-item>
            <el-form-item label="施工地址">
              <el-input v-model="currentCustomAddress" disabled></el-input>
            </el-form-item>
            <el-form-item label="经营主体" prop="businessEntityId">
              <el-select v-model="businessEntityForm.businessEntityId" placeholder="请选择经营主体" filterable clearable
                style="width: 100%;" :remote-method="handleBusinessEntityRemoteSearch" remote>
                <el-option v-for="item in businessEntityList" :key="item.id" :label="item.entityName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="text" icon="el-icon-close" @click="businessEntityDialogVisible = false">取消</el-button>
          <el-button type="text" @click="confirmBusinessEntityBinding" icon="el-icon-check">确定绑定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="下载防水费用拆分" :visible.sync="costDetailDownloadVisible" width="520px"
        :close-on-click-modal="false">
        <el-form label-width="90px">
          <el-form-item label="生成时间">
            <el-date-picker v-model="costDetailTimeRange" type="datetimerange" value-format="timestamp"
              range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
              style="width: 100%;"></el-date-picker>
          </el-form-item>
          <el-form-item label="历史版本">
            <el-checkbox v-model="costDetailIncludeHistory">包含已反审核历史版本</el-checkbox>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-close" @click="costDetailDownloadVisible = false">取消</el-button>
          <el-button type="primary" icon="el-icon-download" :loading="costDetailDownloading"
            @click="confirmCostDetailDownload">下载</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="materialDownloadKind === 'pending' ? '下载防水待核销材料' : '下载防水预约核销材料'"
        :visible.sync="materialDownloadVisible" width="520px" :close-on-click-modal="false">
        <el-form label-width="90px">
          <el-form-item :label="materialDownloadKind === 'pending' ? '保存时间' : '核销时间'">
            <el-date-picker v-model="materialTimeRange" type="datetimerange" value-format="timestamp"
              range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
              style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-close" @click="materialDownloadVisible = false">取消</el-button>
          <el-button type="primary" icon="el-icon-download" :loading="materialDownloading"
            @click="confirmMaterialDownload">下载</el-button>
        </span>
      </el-dialog>
      <finance-export-batch-dialog :visible.sync="financeExportVisible"
        project-type="WATERPROOF"></finance-export-batch-dialog>
      <el-dialog title="输入代金券" :visible.sync="merchantFeePrintDialogVisible" width="420px"
        :close-on-click-modal="false" append-to-body>
        <el-form label-width="110px">
          <el-form-item label="费用合计">
            <span>{{ merchantFeePrintContext ? merchantFeePrintContext.total.toFixed(2) : '0.00' }} 元</span>
          </el-form-item>
          <el-form-item label="代金券金额">
            <el-input-number v-model="merchantFeePrintVoucher" :min="0"
              :max="merchantFeePrintContext ? merchantFeePrintContext.total : 0" :precision="2"
              :step="1" controls-position="right" style="width: 100%;"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelMerchantFeePrint">取消</el-button>
          <el-button type="primary" icon="el-icon-printer" @click="confirmMerchantFeePrint">打印</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { resolveUrlPath } from "@/util/util";
import { waterProofTableOption } from "@/const/work/waterProof/merchantsOption";
import {
  getAgentList, addDeliveryOrder, getDeliveryOrder, updateDeliveryOrder, findWaterProof, addWaterProof, editWaterProof, delWaterProof,
  findWaterProofAll, downloadExcelCustomsDeclaration, handleRebates, getDownloadCode,
  getRootDepartmentId, putNextStep, createAcceptanceOrder, updateAcceptanceOrder, addAreaConfig,
  addAreaconfigEd, downloadExcelActualArea, downloadExcelWaterproofDelivery,
  getOrderStatusList, cancelWaterProof, getPhaseList, getWaterProofStage
} from "@/api/work/waterProof/merchants"
import { getPrintCount } from "@/api/work/eliveryOrder";
import {
  buildWaterproofMerchantFeePrintHtml,
  groupWaterproofMerchantFees,
  MERCHANT_FEE_PRINT_SCOPE_MAIN,
  MERCHANT_FEE_PRINT_SCOPE_SUPPLEMENTARY,
  resolveLastEngineeringSubmitTime
} from "@/util/merchantFeePrint";
import { getWarehouseList, } from "@/api/salesCloud/warehouse";
import { findUserList } from "@/api/work/projectService";
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
import { findBindEngineer, addBindEngineer, findEngineer } from "@/api/work/waterProof/merchants";
import { getBusinessEntityList, addShopEntityBind } from '@/api/salesCloud/businessEntity/businessEntity';
import ImageUpload from "@/components/imageUpload/ImageUpload";
import FinanceExportBatchDialog from "@/components/financeExportBatch";
import { createFinanceExportBatch, downloadFinanceExportBatch } from "@/api/work/financeExportBatch";
import viewAreaOrder from "./components/viewAreaOrder.vue";
import viewAcceptanceOrder from "./components/viewAcceptanceOrder.vue";
import viewWaterProofStage from "./components/viewWaterProofStage.vue";
import viewOrder from "./components/viewOrder.vue";
import viewEvaluation from "./components/viewEvaluation.vue";
import assignEngineerStage from "./components/assignEngineerStage.vue";
import MerchantView from "./view.vue";
import afterSales from "./components/afterSales/index.vue";
import afterSaleListDialog from "@/views/salesCloud/afterSale/components/listByParentDialog.vue";
import viewMeasurementForm from "./components/viewMeasurementForm.vue";
export default {
  name: "waterProof",
  components: {
    ImageUpload,
    FinanceExportBatchDialog,
    viewAreaOrder,
    viewAcceptanceOrder,
    viewWaterProofStage,
    viewOrder,
    viewEvaluation,
    assignEngineerStage,
    MerchantView,
    afterSales,
    afterSaleListDialog,
    viewMeasurementForm
  },
  data() {
    return {
      tableOption: waterProofTableOption, 
      tableData: [], 
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      tempInfo: {},
      users: [],
      wforderStatus: "",
      rules: {
        engineerId: [
          { required: true, message: "请选择工程师", trigger: "change" }
        ],
      },
      agentList: [],
      page: {
        total: 0, 
        currentPage: 1, 
        pageSize: 30 
      },
      dialogVisible: false,
      viewOrderVisible: false,
      evaluateInfo: false,
      totalPrice: 0,
      WarehouseList: [],
      downloadData: {},
      rootDepartmentId: "",
      superiors: [],
      superior: {},
      picUrl: "",
      fileList: [],
      orderId: "",
      engineeringOrderId: "",
      idNow: "",
      steps: new Map([
        [1, { label: "是否派单", value: '', hasInput: true, dialogTitle: "请输入施工员" }],
        [2, { label: "涂料已刷", value: '', hasInput: false, dialogTitle: "" }],
        [3, { label: "闭水", value: '', hasInput: true, dialogTitle: "请输入验收员" }],
        [4, { label: "是否审核", value: '', hasInput: false, dialogTitle: "" }],
      ]),
      inputValue: "", 
      isDialogVisible: false, 
      dialogAcceptanceVisible: false, 
      viewAcceptanceVisible: false,
      isLoading: false, 
      superiorEr: {
        engineerId: "",
        declarationId: "",
      },
      rowInfo: {},
      currentRow: {}, 
      waterproofAreaDialogVisible: false,
      viewStageVisible: false,
      areaForm: {
        name: '',
        area: '',
      },
      areaNameOptions: [],
      waterproofAreaList: [],
      dynamicFormList: [], 
      deductAreaDialogVisible: false, 
      currentDeductAreaIndex: null,   
      tempDeductAreaList: [],         
      tempTotalDeductArea: "0.00",    
      deductAreaForm: {               
        typeIndex: 0,
        length: "",
        width: "",
        radius: "",
        base: "",
        height: "",
        customArea: "",
        area: "0.00",
        topBase: "",
        bottomBase: "",
        trapHeight: "",
      },
      deductAreaTypeOptions: ["矩形", "圆形", "三角形", "梯形", "异形"],
      hasSetDefaultAgent: false,
      dialogVisible1: false,
      loadingEngineers: false,
      engineers: "",
      assignForm: {
        declarationId: '',
        engineeringSupervisor: ''
      },
      rules1: {
        engineeringSupervisor: [
          {
            required: true,
            message: "请选择监理",
            trigger: "change"
          }
        ]
      },
      businessEntityDialogVisible: false,
      businessEntityList: [],
      businessEntityForm: {
        businessEntityId: ''
      },
      currentShopId: null,
      currentShopName: '',
      currentShopMobile: '',
      currentCustomAddress: '',
      businessEntityLoading: false,
      assignEngineerVisible: false,
      assignEngineerOrderId: '',
      assignEngineerOrderInfo: {},
      orderStatusList: [],
      stageStatusList: [],
      // 查看评价弹窗
      evaluationVisible: false,
      evaluationOrderId: '',
      evaluationDeclaration: {},
      // 售后报单
      handleAfterSalesDialog: false,
      afterSalesRow: {},
      // 查看关联售后单弹窗
      afterSaleListVisible: false,
      afterSaleListRow: {},
      // 查看商户报单弹窗
      viewDialogVisible: false,
      viewId: '',
      // 查看收方表弹窗
      measurementFormVisible: false,
      measurementFormOrderId: '',
      measurementFormType: 'NORMAL',
      costDetailDownloadVisible: false,
      costDetailTimeRange: [],
      costDetailIncludeHistory: false,
      costDetailDownloading: false,
      materialDownloadVisible: false,
      materialTimeRange: [],
      materialDownloadKind: 'pending',
      materialDownloading: false,
      financeExportVisible: false,
      merchantFeePrintDialogVisible: false,
      merchantFeePrintLoadingKey: '',
      merchantFeePrintVoucher: 0,
      merchantFeePrintContext: null,
      MERCHANT_FEE_PRINT_SCOPE_MAIN,
      MERCHANT_FEE_PRINT_SCOPE_SUPPLEMENTARY
    };
  },
  created() {
    this.getAgentList();
    this.handleList();
    this.handleWarehouseList();
    this.getOrderStatus(); 
    this.getPhaseOptions(); 
  },
  watch: {
    agentList(newVal) {
      if (!this.hasSetDefaultAgent && Array.isArray(newVal) && newVal.length) {
        const first = newVal[0];
        this.$nextTick(() => {
          if (this.$refs && this.$refs.crud && this.$refs.crud.searchForm) {
            if (!this.$refs.crud.searchForm.rootDepartId) {
              this.$set(this.$refs.crud.searchForm, 'rootDepartId', first.value);
              this.hasSetDefaultAgent = true;
              this.searchChange({ ...this.$refs.crud.searchForm });
            }
          }
        });
      }
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["permission"]),
    currentDialogTitle() {
      const step = this.steps.get(this.rowInfo.step);
      return step ? step.dialogTitle : "";
    },
    isInputVisible() {
      const step = this.steps.get(this.rowInfo.step);
      return step ? step.hasInput : false;
    },
  },
  props: [],
  methods: {
    orderStatusType(label) {
      const map = {
        '待指派': 'info',
        '待受理': 'info',
        '服务中': 'warning',
        '待确认': '',
        '待终审': '',
        '待评价': '',
        '已完成': 'success',
        '已作废': 'danger',
      };
      return map[label] !== undefined ? map[label] : 'info';
    },
    phaseStatusType(status) {
      const map = {
        'WAIT_FOR_ASSIGN': 'info',       
        'WAIT_ACCEPT': 'info',           
        'IN_SERVICE': 'warning',         
        'TO_BE_CONFIRMED': '',           
        'TO_BE_THE_FINAL': '',           
        'TO_BE_EVALUATED': '',           
        'COMPLETE': 'success',           
        'CANCELLED': 'danger',           
      };
      return map[status] !== undefined ? map[status] : 'info';
    },
    phaseStatusLabel(status) {
      const map = {
        'WAIT_FOR_ASSIGN': '待指派',
        'IN_SERVICE': '服务中',
        'WAIT_ACCEPT': '待受理',
        'TO_BE_CONFIRMED': '待确认',
        'TO_BE_THE_FINAL': '待终审',
        'TO_BE_EVALUATED': '待评价',
        'COMPLETE': '已完成',
        'CANCELLED': '已作废',
      };
      return map[status] || status;
    },
    async getAgentList() {
      const res = await getAgentList();
      if (res.code == "200") {
        this.agentList = JSON.parse(res.data);
        this.agentList = this.agentList.map(item => ({
          ...item,
          label: item.company,
          value: item.id,
        }));
        const idx = Array.isArray(this.tableOption.column)
          ? this.tableOption.column.findIndex(col => col && col.prop === "rootDepartId")
          : -1;
        if (idx !== -1) {
          this.$set(this.tableOption.column[idx], "dicData", this.agentList);
        }
      }
    },
    async getEngineers() {
      this.loadingEngineers = true;  
      const params = { type: "JOINS_ENGINEER", manager: "SUPERVISOR", page: 1, size: 100 };
      try {
        const res = await findBindEngineer(params);
        if (res.code === "200") {
          this.engineers = JSON.parse(res.data).rows || [];
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error("获取监理失败");
      } finally {
        this.loadingEngineers = false;  
      }
    },
    async handleAssign(row) {
      this.dialogVisible1 = true;
      this.assignForm = {
        declarationId: row.id,
        engineeringSupervisor: ''
      };
      await this.getEngineerByServiceOrderId(row.id);
    },
    saveInfo() {
      if (!this.assignForm.engineeringSupervisor) {
        this.$message.error("请选择监理");
        return;
      }
      this.$confirm("是否确认指派监理?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        addBindEngineer(this.assignForm).then((res) => {
          if (res.code == "200") {
            this.$message({
              type: "success",
              message: "指派成功!"
            });
            this.dialogVisible1 = false;
            this.handleList(); 
          } else if (res.code == "24022061") {
            this.$message.warning(res.message || '报单商家经营主体不存在，请设置经营主体！');
            const currentRow = this.tableData.find(item => item.id === this.assignForm.declarationId);
            if (currentRow) {
              this.openBusinessEntityDialog(currentRow.shopId, currentRow.shopName, currentRow.contactMobile, currentRow.customAddress);
            }
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
          }
        });
      });
    },
    cancel1() {
      this.dialogVisible1 = false;
    },
    async getEngineerByServiceOrderId(id) {
      const params = { declarationId: id, type: "WATERPROOF" };
      try {
        const res = await findEngineer(params);
        if (res.code === "200") {
          let data = JSON.parse(res.data).rows;
          if (data && data.length > 0) {
            this.assignForm.engineeringSupervisor = data[0].engineeringSupervisor || '';
          }
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error('获取监理数据失败');
      }
    },
    openBusinessEntityDialog(shopId, shopName, shopMobile, customAddress) {
      this.currentShopId = shopId;
      this.currentShopName = shopName;
      this.currentShopMobile = shopMobile;
      this.currentCustomAddress = customAddress;
      this.businessEntityDialogVisible = true;
      this.getBusinessEntityList();
    },
    handleBindBusinessEntity() {
      this.openBusinessEntityDialog(this.currentShopId, this.currentShopName, this.currentShopMobile, this.currentCustomAddress);
    },
    getBusinessEntityList(entityName = '') {
      this.businessEntityLoading = true;
      const params = {
        page: '1',
        size: '100', 
        entityName: entityName
      };
      getBusinessEntityList(params)
        .then(res => {
          const data = JSON.parse(res.data);
          this.businessEntityList = data.rows || [];
        })
        .finally(() => {
          this.businessEntityLoading = false;
        });
    },
    handleBusinessEntityRemoteSearch(query) {
      this.getBusinessEntityList(query);
    },
    confirmBusinessEntityBinding() {
      if (!this.businessEntityForm.businessEntityId) {
        this.$message.error('请选择要绑定的经营主体');
        return;
      }
      if (!this.currentShopId) {
        this.$message.error('商户信息有误，请重试');
        return;
      }
      const params = [{
        shopId: this.currentShopId,
        businessEntityId: this.businessEntityForm.businessEntityId,
        shopName: this.currentShopName,
        shopMobile: this.currentShopMobile
      }];
      addShopEntityBind(params)
        .then(res => {
          if (res.code == '200') {
            this.$message.success('绑定经营主体成功');
            this.businessEntityDialogVisible = false;
            this.businessEntityForm.businessEntityId = '';
            this.currentShopId = null;
            this.currentShopName = '';
            this.currentCustomAddress = '';
            this.currentShopMobile = '';
          } else {
            this.$message.error(res.message || '绑定经营主体失败');
          }
        });
    },
    handleOpenViewOrder() {
      this.toViewOrder(this.tempInfo);
    },
    handleAssignEngineerStage(row) {
      this.assignEngineerOrderId = row.id;
      this.assignEngineerOrderInfo = { ...row };
      this.currentShopId = row.shopId;
      this.currentShopName = row.shopName;
      this.currentShopMobile = row.contactMobile;
      this.currentCustomAddress = row.customAddress;
      if (!row.shopId) {
        this.$message.warning('报单商家经营主体不存在，请先绑定经营主体！');
        this.openBusinessEntityDialog(row.shopId, row.shopName, row.contactMobile, row.customAddress);
        return;
      }
      this.assignEngineerVisible = true;
    },
    // 报售后弹窗
    handleAfterSales(row) {
      this.afterSalesRow = row;
      this.handleAfterSalesDialog = true;
    },
    // 查看该主订单关联的售后单列表
    handleViewAfterSaleList(row) {
      this.afterSaleListRow = row;
      this.afterSaleListVisible = true;
    },
    toViewOrder(row) {
      this.viewOrderVisible = false;
      this.evaluateInfo = false;
      this.orderId = '';
      this.idNow = '';
      this.totalPrice = 0;
      this.$nextTick(() => {
        this.viewOrderVisible = true;
        this.evaluateInfo = false;
        this.orderId = row.deliveryOrderId || ''
        this.idNow = row.id;
        this.totalPrice = row.totalPrice;
      });
    },
    // 查看评价
    evaluateInfoView(row) {
      this.evaluationVisible = false;
      this.evaluationOrderId = '';
      this.evaluationDeclaration = {};
      this.$nextTick(() => {
        this.evaluationOrderId = row.deliveryOrderId;
        this.evaluationDeclaration = row;
        this.evaluationVisible = true;
      });
    },
    async handleClick(row) {
      const step = this.steps.get(row.step);
      if (row.step > 4) {
        this.$message.error("已完成，不允许点击");
        return;
      }
      if (step.hasInput) {
        this.isDialogVisible = true;
        this.rowInfo = row;
      } else {
        await this.requestStep(row, '');
      }
    },
    async submitInput() {
      if (this.inputValue.trim()) {
        await this.requestStep(this.rowInfo, this.inputValue);
        this.inputValue = "";
        this.isDialogVisible = false;
      } else {
        this.$message.error("请输入有效内容");
      }
    },
    async requestStep(row, val) {
      try {
        this.isLoading = true; 
        var step = "";
        if (row.val) {
          step = row.step + ':' + row.val + "," + val
        } else {
          step = row.step + ':' + val
        }
        const params = {
          step: step,
          id: row.id
        };
        const res = await putNextStep(params);
        if (res.code === "200") {
          this.$message.success(`步骤 ${row.stepName} 完成`);
          this.handleList();
        } else {
          this.$message.error("请求失败，请重试");
        }
      } catch (error) {
        this.$message.error("请求失败，请重试");
      } finally {
        this.isLoading = false; 
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.tabelObj = {};
    },
    confirm() {
      this.$refs["tabelObj"].validate((valid) => {
        if (valid) {
          let params = this.tabelObj;
          params.status = "WAIT_FOR_DELIVERY";
          if (params.deliveryOrderId) {
            getDeliveryOrder(params.deliveryOrderId).then((res) => {
              if (res.code == "200") {
                let data = JSON.parse(res.data).rows[0];
                params = { ...data, ...params };
                updateDeliveryOrder(params).then((res) => {
                  if (res.code == "200") {
                    this.$message({
                      showClose: true,
                      message: "修改提货单成功",
                      type: "success",
                    });
                    this.handleList();
                    this.dialogVisible = false;
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.message,
                      type: "error",
                    });
                  }
                })
              }
            })
          } else {
            addDeliveryOrder(params).then((res) => {
              if (res.code == "200") {
                this.$message({
                  showClose: true,
                  message: "生成提货单成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            });
          }
          this.tabelObj = {};
          this.dialogVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: "请填写完整信息",
            type: "error",
          });
        }
      });
    },
    handleRemote(query) {
      // eslint-disable-next-line no-control-regex
      if (/[^\x00-\xff]/.test(query)) {
        this.users = [];
        setTimeout(() => {
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.users = data
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      } else if (/^\d{11}$/.test(query)) {
        this.users = [];
        setTimeout(() => {
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.users = data
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      }
    },
    handleWarehouseList() {
      let params = {
        page: 1,
        size: 100,
      };
      getWarehouseList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.WarehouseList = data.rows;
      });
    },
    handleDelivery(row) {
      this.dialogVisible = true;
      this.tabelObj.deliveryOrderId = row.deliveryOrderId ? row.deliveryOrderId : "";
      this.tabelObj.shopId = row.shopId;
      this.tabelObj.declarationId = row.id;
      if (this.$refs.crud && this.$refs.crud.searchForm && this.$refs.crud.searchForm.rootDepartId) {
        this.tabelObj.rootDepartId = this.$refs.crud.searchForm.rootDepartId;
      }
    },
    handleAcceptance(row) {
      this.dialogAcceptanceVisible = true;
      this.superiorEr.declarationId = row.id;
      this.superiorEr.contactsMobile = row.contactMobile;
      this.superiorEr.engineeringOrderId = row.engineeringOrderId
      this.superiorEr.type = "ACCEPTANCE";
    },
    viewAcceptance(row) {
      this.evaluateInfo = false;
      this.viewAcceptanceVisible = true;
      this.engineeringOrderId = row.engineeringOrderId;
      this.idNow = row.id;
    },
    handleViewStage(row) {
      this.tempInfo = row;
      this.idNow = row.id;
      this.wforderStatus = row.orderStatus;
      this.viewStageVisible = true;
    },
    async handlePrintMerchantFees(row, scope = MERCHANT_FEE_PRINT_SCOPE_MAIN) {
      const supplementary = scope === MERCHANT_FEE_PRINT_SCOPE_SUPPLEMENTARY;
      this.merchantFeePrintLoadingKey = `${row.id}:${scope}`;
      try {
        const response = await getWaterProofStage(row.id);
        if (!response || response.code != "200" || !response.data) {
          this.$message.error((response && response.message) ||
            (supplementary ? "获取商家补刷费用失败" : "获取商家费用失败"));
          return;
        }
        const parsed = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
        const costData = Array.isArray(parsed) ? parsed : [parsed];
        const grouped = groupWaterproofMerchantFees(costData, scope);
        if (!grouped.groups.length) {
          this.$message.warning(supplementary ? "暂无商家补刷费用数据" : "暂无商家费用数据");
          return;
        }
        this.merchantFeePrintContext = {
          declaration: {
            ...row,
            lastEngineeringSubmitTime: resolveLastEngineeringSubmitTime(costData)
          },
          groups: grouped.groups,
          total: grouped.total,
          engineeringOrderId: row.engineeringOrderId || "",
          scope
        };
        this.merchantFeePrintVoucher = 0;
        this.merchantFeePrintDialogVisible = true;
      } catch (error) {
        this.$message.error((error && error.message) ||
          (supplementary ? "获取商家补刷费用失败" : "获取商家费用失败"));
      } finally {
        this.merchantFeePrintLoadingKey = '';
      }
    },
    cancelMerchantFeePrint() {
      this.merchantFeePrintDialogVisible = false;
      this.merchantFeePrintVoucher = 0;
      this.merchantFeePrintContext = null;
    },
    async confirmMerchantFeePrint() {
      const context = this.merchantFeePrintContext;
      if (!context || !context.groups || !context.groups.length) {
        this.$message.warning("暂无商家费用数据");
        return;
      }
      const voucher = Number(this.merchantFeePrintVoucher) || 0;
      if (voucher < 0 || voucher > context.total) {
        this.$message.warning("代金券金额不能大于费用合计");
        return;
      }
      const printWindow = window.open("", "_blank");
      if (!printWindow) {
        this.$message.warning("浏览器阻止了打印窗口，请允许弹出窗口后重试");
        return;
      }
      this.merchantFeePrintDialogVisible = false;
      printWindow.document.write("<p style='font-family:sans-serif;padding:20px;'>正在准备打印内容...</p>");
      printWindow.document.close();

      const trackPrintCount = Boolean(context.engineeringOrderId);
      let currentPrintCount = 0;
      if (trackPrintCount) {
        try {
          const response = await getPrintCount({ orderId: context.engineeringOrderId, count: 0 });
          if (response && response.code == "200") {
            currentPrintCount = Number(response.data) || 0;
          }
        } catch (error) {
          currentPrintCount = 0;
        }
      }

      const printContent = buildWaterproofMerchantFeePrintHtml({
        declaration: context.declaration,
        groups: context.groups,
        total: context.total,
        voucher,
        printCount: currentPrintCount,
        trackPrintCount
      });
      printWindow.document.open();
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.addEventListener("afterprint", () => {
        printWindow.close();
        if (trackPrintCount) {
          this.$nextTick(() => {
            this.$confirm("是否打印成功?", "提示", {
              confirmButtonText: "是",
              cancelButtonText: "否",
              type: "warning"
            }).then(() => {
              getPrintCount({ orderId: context.engineeringOrderId, count: 1 });
            }).catch(() => {
              getPrintCount({ orderId: context.engineeringOrderId, count: 0 });
            });
          });
        }
      });
      window.setTimeout(() => {
        printWindow.focus();
        printWindow.print();
      }, 100);
      this.merchantFeePrintVoucher = 0;
      this.merchantFeePrintContext = null;
    },
    // 查看收方表
    handleViewMeasurementForm(row, type) {
      this.measurementFormOrderId = row.engineeringOrderId;
      this.measurementFormType = type || 'NORMAL';
      this.measurementFormVisible = true;
    },
    // 判断是否存在涂料补刷阶段且状态为服务中
    hasSupplementaryPhase(phaseList) {
      if (!phaseList || !phaseList.length) return false;
      return phaseList.some(p => p.name === '涂料补刷');
    },
    // 销售出库单打印
    handlePrintOutbound(row) {
      this.tempInfo = row;
      this.idNow = row.id;
      this.engineeringOrderId = row.engineeringOrderId;
      this.$nextTick(() => {
        if (this.$refs.viewAcceptanceRef) {
          this.$refs.viewAcceptanceRef.handlePrintOutbound();
        }
      });
    },
    confirmHandleAcceptance() {
      this.$refs["superiorEr"].validate((valid) => {
        if (valid) {
          var params = {
            ...this.superiorEr,
          }
          if (params.engineeringOrderId) {
            const params1 = {
              id: this.superiorEr.engineeringOrderId,
              engineerId: this.superiorEr.engineerId,
              status: 'WAIT_ACCEPT'
            };
            updateAcceptanceOrder(params1).then((res) => {
              if (res.code == "200") {
                this.$message({
                  showClose: true,
                  message: "生成验收单成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            });
          } else {
            createAcceptanceOrder(params).then((res) => {
              if (res.code == "200") {
                this.$message({
                  showClose: true,
                  message: "生成验收单成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            });
          }
          this.superiorEr = {};
          this.dialogAcceptanceVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: "请填写完整信息",
            type: "error",
          });
        }
      });
    },
    cancelHandleAcceptance() {
      this.dialogAcceptanceVisible = false;
      this.superiorEr = {};
    },
    viewDelivery(row) {
      let obj = {
        label: "查看提货单",
        value: "/work/eliveryOrder/view",
        query: { id: row.deliveryOrderId, type: row.type },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    downloadCode(type) {
      this.$confirm("是否确认生成通用码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        if (!this.rootDepartmentId) {
          const res = await getRootDepartmentId();
          this.rootDepartmentId = res.data;
        }
        const data = {
          scene: this.rootDepartmentId,
          page: type.type == 1 ? "pages/waterProof/install/install" : "pages/waterProof/customer/customer",
          width: "340",
          clientType: "JOINS_MERCHANT",
        };
        getDownloadCode(data).then((response) => {
          const filename = response.headers["content-disposition"].match(
            /filename=(.*)/
          )[1];
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            window.navigator.msSaveBlob(blob, decodeURI(filename));
          } else {
            const blobURL = window.URL.createObjectURL(blob);
            const tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", decodeURI(filename));
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
            this.searchChange(this.downloadData);
          }
        });
      })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消生成通用码"
          });
        });
    },
    handleSuperior() {
      findWaterProofAll().then((res) => {
        let data = JSON.parse(res.data)
        this.superiors = data
      })
    },
    handleUploaded(url) {
      this.picUrl = url;
      this.tableLoading = false;
    },
    formmaterImage(row) {
      let str = new Array();
      JSON.stringify(row);
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          str.push(picArray[i]);
        }
      }
      return str;
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage,
        params.size = pageSize
      findWaterProof(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      })
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page
      params.size = this.page.pageSize
      findWaterProof(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      })
    },
    searchChange(params) {
      this.tableLoading = true;
      params.page = this.page.currentPage
      params.size = this.page.pageSize
      this.downloadData = params;
      findWaterProof(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      })
    },
    downloadExcelWorkOrder() {
      let params = this.downloadData;
      if (!params) {
        this.$message.error("导出参数未定义，请先进行一次查询操作！");
        return;
      }
      downloadExcelCustomsDeclaration(params).then((response) => {
        const filename = response.headers["content-disposition"].match(
          /filename=(.*)/
        )[1];
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(blob, decodeURI(filename));
        } else {
          const blobURL = window.URL.createObjectURL(blob);
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", decodeURI(filename));
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
          this.searchChange(params);
        }
      });
    },
    downloadExcelActualArea() {
      let params = this.downloadData;
      this.$confirm('温馨提示：只会下载已提货的报单数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        downloadExcelActualArea(params).then((response) => {
          const filename = response.headers["content-disposition"].match(
            /filename=(.*)/
          )[1];
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            window.navigator.msSaveBlob(blob, decodeURI(filename));
          } else {
            const blobURL = window.URL.createObjectURL(blob);
            const tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", decodeURI(filename));
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
            this.searchChange(params);
          }
        });
      }).catch(() => {
      })
    },
    downloadExcelWaterproofDelivery() {
      let params = this.downloadData;
      this.$confirm('温馨提示：只会下载已提货的报单数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        downloadExcelWaterproofDelivery(params).then((response) => {
          const filename = response.headers["content-disposition"].match(
            /filename=(.*)/
          )[1];
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            window.navigator.msSaveBlob(blob, decodeURI(filename));
          } else {
            const blobURL = window.URL.createObjectURL(blob);
            const tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", decodeURI(filename));
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
            this.searchChange(params);
          }
        });
      }).catch(() => {
      })
    },
    openCostDetailDownload() {
      const now = new Date();
      const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      this.costDetailTimeRange = [startOfDay, startOfDay + 24 * 60 * 60 * 1000 - 1];
      this.costDetailIncludeHistory = false;
      this.costDetailDownloadVisible = true;
    },
    confirmCostDetailDownload() {
      if (!Array.isArray(this.costDetailTimeRange) || this.costDetailTimeRange.length !== 2) {
        this.$message.warning("请选择费用拆分生成时间");
        return;
      }
      this.costDetailDownloading = true;
      let createdBatch = null;
      createFinanceExportBatch({
        exportType: "WATERPROOF_COST",
        startTime: this.costDetailTimeRange[0],
        endTime: this.costDetailTimeRange[1],
        includeHistory: this.costDetailIncludeHistory
      }).then((batch) => {
        createdBatch = batch;
        return downloadFinanceExportBatch(batch.id);
      }).then((response) => {
        this.saveCostDetailFile(response, "防水劳务材料费明细.xlsx");
        this.costDetailDownloadVisible = false;
        this.$message.success(`已生成财务批次 ${createdBatch.batchNo}`);
      }).catch((error) => {
        if (createdBatch && createdBatch.batchNo) {
          this.$message.warning(`批次 ${createdBatch.batchNo} 已生成，文件可在财务导出记录中重新下载`);
        } else {
          this.$message.error(error && error.message ? error.message : "生成财务导出批次失败");
        }
      }).then(() => {
        this.costDetailDownloading = false;
      });
    },
    openMaterialDownload(kind) {
      const now = new Date();
      const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      this.materialDownloadKind = kind;
      if (kind === 'pending') {
        const yesterdayAt16 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 16, 0, 0, 0).getTime();
        const todayAt1559 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15, 59, 59, 999).getTime();
        this.materialTimeRange = [yesterdayAt16, todayAt1559];
      } else {
        this.materialTimeRange = [startOfDay, startOfDay + 24 * 60 * 60 * 1000 - 1];
      }
      this.materialDownloadVisible = true;
    },
    confirmMaterialDownload() {
      if (!Array.isArray(this.materialTimeRange) || this.materialTimeRange.length !== 2) {
        this.$message.warning("请选择时间范围");
        return;
      }
      const pending = this.materialDownloadKind === 'pending';
      this.materialDownloading = true;
      let createdBatch = null;
      createFinanceExportBatch({
        exportType: pending ? "WATERPROOF_PENDING_WRITE_OFF" : "WATERPROOF_WRITTEN_OFF",
        startTime: this.materialTimeRange[0],
        endTime: this.materialTimeRange[1]
      }).then((batch) => {
        createdBatch = batch;
        return downloadFinanceExportBatch(batch.id);
      }).then((response) => {
        this.saveCostDetailFile(response, pending ? "防水待核销材料明细.xlsx" : "防水已核销材料明细.xlsx");
        this.materialDownloadVisible = false;
        this.$message.success(`已生成财务批次 ${createdBatch.batchNo}`);
      }).catch((error) => {
        if (createdBatch && createdBatch.batchNo) {
          this.$message.warning(`批次 ${createdBatch.batchNo} 已生成，文件可在财务导出记录中重新下载`);
        } else {
          this.$message.error(error && error.message ? error.message : "生成财务导出批次失败");
        }
      }).then(() => {
        this.materialDownloading = false;
      });
    },
    saveCostDetailFile(response, fallbackName) {
      const disposition = response.headers["content-disposition"] || "";
      const matched = disposition.match(/filename=(.*)/);
      let filename = matched ? matched[1].replace(/^\"|\"$/g, "") : fallbackName;
      try {
        filename = decodeURI(filename);
      } catch (e) {
        filename = fallbackName;
      }
      const blob = new Blob([response.data], { type: "application/octet-stream" });
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(blob, filename);
        return;
      }
      const blobURL = window.URL.createObjectURL(blob);
      const tempLink = document.createElement("a");
      tempLink.style.display = "none";
      tempLink.href = blobURL;
      tempLink.setAttribute("download", filename);
      if (typeof tempLink.download === "undefined") {
        tempLink.setAttribute("target", "_blank");
      }
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page.currentPage
      params.size = page.pageSize
      findWaterProof(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      })
    },
    async getOrderStatus() {
      try {
        const res = await getOrderStatusList('type=water_proof_declaration');
        if (res.code == "200") {
          this.orderStatusList = JSON.parse(res.data);
          this.orderStatusList = this.orderStatusList.map(item => ({
            label: item.name,
            value: item.code
          }));
          const idx = Array.isArray(this.tableOption.column)
            ? this.tableOption.column.findIndex(col => col && col.prop === "orderStatus")
            : -1;
          if (idx !== -1) {
            this.$set(this.tableOption.column[idx], "dicData", this.orderStatusList);
          }
        }
      } catch (error) {
        this.$message.error("获取订单状态失败");
      }
    },
    async getPhaseOptions() {
      try {
        const deptRes = await getRootDepartmentId();
        const rootDepartId = deptRes.data;
        if (!rootDepartId) return;
        const res = await getPhaseList(rootDepartId);
        if (res.code == "200") {
          const phaseData = JSON.parse(res.data) || [];
          const phaseOptions = phaseData.map(item => ({
            label: item.goodsName || item.name,
            value: item.id
          }));
          const idx = Array.isArray(this.tableOption.column)
            ? this.tableOption.column.findIndex(col => col && col.prop === "step")
            : -1;
          if (idx !== -1) {
            this.$set(this.tableOption.column[idx], "dicData", phaseOptions);
          }
        }
      } catch (error) {
      }
    },
    async getStageStatus() {
      try {
        const res = await getOrderStatusList('type=engineering');
        if (res.code == "200") {
          this.stageStatusList = JSON.parse(res.data);
          this.stageStatusList = this.stageStatusList.map(item => ({
            label: item.name,
            value: item.code
          }));
          const idx = Array.isArray(this.tableOption.column)
            ? this.tableOption.column.findIndex(col => col && col.prop === "stageStatus")
            : -1;
          if (idx !== -1) {
            this.$set(this.tableOption.column[idx], "dicData", this.stageStatusList);
          }
        }
      } catch (error) {
        this.$message.error("获取阶段状态失败");
      }
    },
    handleAdd() {
      this.cleanForm();
      this.$refs.crud.rowAdd();
    },
    handleView(row) {
      this.viewId = row.id;
      this.viewDialogVisible = true;
    },
    handleEdit(row) {
      let obj = {
        label: "编辑商户报单",
        value: "/work/waterProof/merchants/edit",
        query: { id: row.id, number: row.number },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    getStep() {
      for (var i = 0; i < this.tableData.length; i++) {
        let row = this.tableData[i];
        if (row.step == null || row.step == 0) {
          row.step = 0;
        } else {
          var step1 = row.step.split(":");
          row.step = step1[0];
          var val = step1[1];
          if (val) {
            row.val = val;
          } else {
            row.val = "";
          }
        }
        row.step = Number(row.step) + 1;
        if (row.step > this.steps.size) {
          row.stepName = "已完成";
        } else {
          row.stepName = this.steps.get(row.step).label;
        }
      }
    },
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      }
      this.downloadData = parmas;
      findWaterProof(parmas).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.getStep();
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        getRootDepartmentId().then(res => {
          let data = res.data;
          this.rootDepartmentId = data;
        });
        this.tableLoading = false;
      })
      this.handleSuperior();
    },
    cleanForm() {
      this.superior = {};
      this.superior.id = null;
      this.picUrl = "";
      this.fileList = [];
    },
    handleSave(row, done) {
      row.superiorId = this.superior.id;
      row.picUrl = this.picUrl;
      addWaterProof(row).then(response => {
        if (response.code == '200') {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success"
          });
          this.cleanForm();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          })
        }
      }).catch(error => {
        this.loading = false
        this.$message({
          showClose: true,
          message: error,
          type: "error"
        })
      })
      done();
    },
    handleSelectionChange(val) {
      this.tableRow = val;
    },
    handleDel() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        })
        return
      }
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id)
          }
          delWaterProof(ids).then(response => {
            if (response.code == '200') {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              })
            }
          }).catch(error => {
            this.loading = false
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            })
          })
        })
        .catch(() => { });
    },
    handleUpdate(row, index, done) {
      row.superiorId = this.superior.id
      row.picUrl = this.picUrl;
      editWaterProof(row).then(response => {
        if (response.code == '200') {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          this.cleanForm();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          })
        }
      }).catch(error => {
        this.loading = false
        this.$message({
          showClose: true,
          message: error,
          type: "error"
        })
      })
      done();
    },
    handleRebates(row) {
      this.$confirm(`是否确认返利?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          handleRebates(row.id).then(response => {
            if (response.code == '200') {
              this.$message({
                showClose: true,
                message: "返利成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              })
            }
          }).catch(error => {
            this.loading = false
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            })
          })
        })
    },
    handleCancelOrder(row) {
      this.$prompt('请输入作废原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: '请输入正确长度的作废原因1-255',
      }).then(({ value }) => {
        let params = {
          afterSaleId: "",
          projectType: 'WATERPROOF_PROJECT',
          reason: value,
          declarationId: row.id || '',
        };
        cancelWaterProof(params).then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "工单已成功作废",
              type: "success",
            });
            this.handleList(); 
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消作废'
        });
      });
    },
    handleDetail(row, index) {
      this.superior = {};
      this.superior.id = row.superiorId;
      this.picUrl = row.picUrl;
      this.$refs.crud.rowView(row, index)
    },
    addWaterproofArea() {
      const name = this.areaForm.name;
      if (!name) {
        this.$message.error("请选择区域名称");
        return;
      }
      if (!this.areaForm.area) {
        this.$message.error("请输入面积");
        return;
      }
      const area = parseFloat(this.areaForm.area);
      if (isNaN(area) || area <= 0) {
        this.$message.error("面积必须为大于0的数字");
        return;
      }
      let finalName = name;
      if (name === "其他") {
        this.$prompt('请输入区域名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /.+/,
          inputErrorMessage: '区域名称不能为空'
        }).then(({ value }) => {
          finalName = value;
          this.addAreaToList(finalName, area);
        }).catch(() => {
        });
      } else {
        this.addAreaToList(finalName, area);
      }
    },
    addAreaToList(name, area) {
      const regex = new RegExp(`^${name}(\\d+)$`);
      let maxIndex = 0;
      this.waterproofAreaList.forEach(item => {
        const match = item.name.match(regex);
        if (match) {
          const num = parseInt(match[1], 10);
          if (num > maxIndex) maxIndex = num;
        }
      });
      const count = maxIndex + 1;
      this.waterproofAreaList.push({
        name: `${name}${count}`,
        area: area, 
        subArea: "0.00", 
        jsonData: JSON.stringify([]) 
      });
      this.areaForm = {
        name: '',
        area: '',
      };
    },
    onAreaInput(row) {
      row.area = parseFloat(row.area);
    },
    deleteWaterproofArea(index) {
      this.waterproofAreaList.splice(index, 1);
    },
    submitWaterproofArea() {
      if (this.waterproofAreaList.length === 0) {
        this.$message.error("请添加防水面积配置");
        return;
      }
      const hasOther = this.dynamicFormList.some(item => item.fieldValue && item.fieldValue !== "");
      if (!hasOther) {
        this.$message.error("请填写至少一个其他配置");
        return;
      }
      const declarationId = this.currentRow.id;
      const areaParams = {
        declarationId,
        areaConfigList: this.waterproofAreaList.map(item => ({
          ...item,
          jsonData: Array.isArray(item.jsonData) ? JSON.stringify(item.jsonData) : item.jsonData
        }))
      };
      const otherParams = {
        declarationId,
        otherList: this.dynamicFormList
          .filter(item => item.fieldValue && item.fieldValue !== "") 
          .map(item => ({
            id: item.id,
            fieldName: item.fieldName,
            fieldValue: item.fieldValue,
            inputType: item.inputType,
            declarationId
          }))
      };
      this.isLoading = true;
      Promise.all([
        addAreaConfig(areaParams),
        addAreaconfigEd(otherParams)
      ]).then(([res1, res2]) => {
        if (res1.code === '200' && res2.code === '200') {
          this.$message.success("防水面积配置提交成功");
          this.handleList();
        } else {
          this.$message.error(res1.message || res2.message || "提交失败");
        }
      }).catch(err => {
        this.$message.error(err.message || "提交失败");
      }).finally(() => {
        this.isLoading = false;
        this.waterproofAreaDialogVisible = false;
      });
    },
    openWaterproofAreaDialog(row) {
      this.currentRow = row;
      this.waterproofAreaList = row.areaConfigEngineer
        ? JSON.parse(JSON.stringify(row.areaConfigEngineer)).map(item => ({
          ...item,
          jsonData: typeof item.jsonData === 'string' ? item.jsonData : JSON.stringify(item.jsonData || [])
        }))
        : [];
      this.waterproofAreaDialogVisible = true;
      this.areaForm = {
        name: "",
        area: "",
      };
      this.areaNameOptions = ["阳台", "卫生间", "厨房", "其他"];
      this.getDynamicFormData(row);
    },
    async getDynamicFormData(row) {
      try {
        const inputTypesRes = await findDataSourceFields();
        const inputTypes = JSON.parse(inputTypesRes.data);
        const params = {
          id: row.deliveryOrderId,
          code: 'WORK_WATERPROOF'
        };
        const res = await evaluateInfoView(params);
        if (res.code === "200") {
          const jsonData = JSON.parse(res.data);
          this.dynamicFormList = jsonData.list
            .filter(item => item.inputType != '8') 
            .map(item => ({
              id: item.id,
              fieldName: item.fieldName,
              fieldValue: item.value || "",
              inputType: this.getInputType(item.inputType, inputTypes)
            }));
        } else {
          this.dynamicFormList = [
            { fieldName: "基坑数量", fieldValue: "", inputType: "number" },
            { fieldName: "丙纶面积", fieldValue: "", inputType: "number" },
            { fieldName: "涤纶面积", fieldValue: "", inputType: "number" },
            { fieldName: "增项", fieldValue: "", inputType: "text" },
            { fieldName: "回填面积", fieldValue: "", inputType: "number" },
            { fieldName: "二排数量", fieldValue: "", inputType: "number" },
            { fieldName: "模具", fieldValue: "", inputType: "text" },
            { fieldName: "楼层", fieldValue: "", inputType: "number" }
          ];
        }
      } catch (error) {
        this.dynamicFormList = [
          { fieldName: "基坑数量", fieldValue: "", inputType: "number" },
          { fieldName: "丙纶面积", fieldValue: "", inputType: "number" },
          { fieldName: "涤纶面积", fieldValue: "", inputType: "number" },
          { fieldName: "增项", fieldValue: "", inputType: "text" },
          { fieldName: "回填面积", fieldValue: "", inputType: "number" },
          { fieldName: "二排数量", fieldValue: "", inputType: "number" },
          { fieldName: "模具", fieldValue: "", inputType: "text" },
          { fieldName: "楼层", fieldValue: "", inputType: "number" }
        ];
      }
    },
    getInputType(inputType, inputTypes) {
      const type = inputTypes.find(item => item.id == inputType);
      if (type && type.name) {
        return type.name === '数字' ? 'number' : 'text';
      }
      return 'text';
    },
    openDeductAreaDialog(row, index) {
      this.deductAreaDialogVisible = true;
      this.currentDeductAreaIndex = index;
      this.tempDeductAreaList = row.jsonData ? JSON.parse(row.jsonData) : [];
      this.tempTotalDeductArea = row.subArea || "0.00";
      this.deductAreaForm = {
        typeIndex: 0,
        length: "",
        width: "",
        radius: "",
        base: "",
        height: "",
        customArea: "",
        area: "0.00",
        topBase: "",
        bottomBase: "",
        trapHeight: "",
      };
    },
    onDeductAreaDialogClose() {
      const index = this.currentDeductAreaIndex;
      if (index !== null && this.waterproofAreaList[index]) {
        this.waterproofAreaList[index].jsonData = JSON.stringify(this.tempDeductAreaList);
        this.waterproofAreaList[index].subArea = this.tempTotalDeductArea;
      }
      this.deductAreaDialogVisible = false;
      this.currentDeductAreaIndex = null;
    },
    onDeductAreaInput() {
      let form = this.deductAreaForm;
      let area = 0;
      switch (parseInt(form.typeIndex)) {
        case 0: 
          if (form.length && form.width) area = parseFloat(form.length) * parseFloat(form.width);
          break;
        case 1: 
          if (form.radius) area = Math.PI * Math.pow(parseFloat(form.radius), 2);
          break;
        case 2: 
          if (form.base && form.height) area = 0.5 * parseFloat(form.base) * parseFloat(form.height);
          break;
        case 3: 
          if (form.topBase && form.bottomBase && form.trapHeight)
            area = ((parseFloat(form.topBase) + parseFloat(form.bottomBase)) * parseFloat(form.trapHeight)) / 2;
          break;
        case 4: 
          if (form.customArea) area = parseFloat(form.customArea);
          break;
      }
      this.deductAreaForm.area = isNaN(area) ? "0.00" : area;
    },
    addDeductArea() {
      const form = this.deductAreaForm;
      const index = this.currentDeductAreaIndex;
      const areaItem = this.waterproofAreaList[index];
      const totalArea = parseFloat(areaItem.area); 
      const currentDeductArea = this.tempDeductAreaList.reduce((sum, item) => sum + parseFloat(item.area), 0);
      const addArea = parseFloat(form.area);
      if (isNaN(totalArea) || totalArea <= 0) {
        this.$message.warning("请先填写有效的房间面积");
        return;
      }
      if (addArea <= 0) {
        this.$message.warning("请填写有效参数");
        return;
      }
      if (currentDeductArea + addArea > totalArea) {
        this.$message.warning("扣除面积不能大于当前项计算出来的面积");
        return;
      }
      let label = "";
      switch (parseInt(form.typeIndex)) {
        case 0:
          label = `矩形(长=${form.length},宽=${form.width},面积=${form.length}×${form.width}=${form.area})`;
          break;
        case 1:
          label = `圆形(半径=${form.radius},面积=π×${form.radius}²=${form.area})`;
          break;
        case 2:
          label = `三角形(底=${form.base},高=${form.height},面积=${form.base}×${form.height}/2=${form.area})`;
          break;
        case 3:
          label = `梯形(上底=${form.topBase},下底=${form.bottomBase},高=${form.trapHeight},面积=(${form.topBase}+${form.bottomBase})×${form.trapHeight}/2=${form.area})`;
          break;
        case 4:
          label = `异形(面积=${form.customArea})`;
          break;
      }
      if (parseFloat(form.area) <= 0) {
        this.$message.warning("请填写有效参数");
        return;
      }
      this.tempDeductAreaList.push({
        type: Number(form.typeIndex),
        label,
        area: form.area,
      });
      this.calcTempTotalDeductArea();
      this.deductAreaForm = {
        typeIndex: form.typeIndex,
        length: "",
        width: "",
        radius: "",
        base: "",
        height: "",
        customArea: "",
        area: "0.00",
        topBase: "",
        bottomBase: "",
        trapHeight: "",
      };
    },
    removeDeductArea(idx) {
      this.tempDeductAreaList.splice(idx, 1);
      this.calcTempTotalDeductArea();
    },
    calcTempTotalDeductArea() {
      const total = this.tempDeductAreaList.reduce((sum, item) => sum + parseFloat(item.area), 0);
      this.tempTotalDeductArea = total;
    },
  }
};
</script>
<style lang="scss" scoped>
.table-container {
  padding: 8px 10px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
::v-deep .el-table--medium td {
  padding: 0 !important;
}
::v-deep .el-table {
  font-size: 12px !important;
}
::v-deep .el-form-item {
  margin-bottom: 0px !important;
}
::v-deep .el-table--medium th {
  padding: 0px !important;
}
::v-deep .el-table td .el-table th {
  padding: 0px !important;
}
</style>
